import { compose, withProps } from 'recompose'
import withType from 'components/common/hoc/withType'
import BOTStoreCityList from './BOTStoreCityList'
import { removeDuplicates } from '../../helpers'

const withStateDetails = withProps(({ cities }) => ({
  hasCities: Boolean(cities.length),
  cities: removeDuplicates({ cities })
}))

export default compose(
  withType({ type: 'BOTStoreCityList' }),
  withStateDetails
)(BOTStoreCityList)
